export const createStrategy = (type) => {
    return (contentBlock, callback, contentState) => {
        contentBlock.findEntityRanges(character => {
          const entityKey = character.getEntity();
          return (
              entityKey && contentState.getEntity(entityKey).getType() === type
          );
      }, callback);
    };
  };